import React from "react";
import "./InputGlobal.scss";

const InputGlobal = ({
  placeholder,
  className,
  name,
  type,
  onChange,
  value,
  onFocus,
  onBlur,
}) => {
  return (
    <input
      autoComplete="on"
      type={type}
      placeholder={placeholder}
      className={className}
      name={name}
      onChange={onChange}
      value={value}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
}

export default InputGlobal;
